<template>
  <div class="flex flex-col items-center overflow-hidden">
    <RevIllustration
      :alt="modelName"
      class="mx-8 my-0 block"
      :height="320"
      :src="image"
      :width="320"
    />

    <div class="py-24">
      <div class="body-1-bold">{{ modelName }}</div>

      <div class="text-static-default-mid body-2">
        {{ priceIncentiveMessage }}
      </div>
    </div>

    <RevButton :to="link" variant="secondary">
      {{ i18n(translations.formProductCallout) }}</RevButton
    >
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { type Link, type Price } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './ModelPreview.translations'

const i18n = useI18n()

const props = defineProps<{
  modelName: string
  price: Price
  image: string
  link: Link
}>()

const priceIncentiveMessage = computed(() =>
  i18n(translations.formProductPriceIncentive, {
    price: props.price.amount,
    currency: props.price.currency,
  }),
)
</script>
